module.exports = __webpack_public_path__ + "img/sv18.74e8f2c2.svg";